module.exports = __webpack_public_path__ + "static/SmartPantry-squirrel-1200x1200-191020-6206507d447254e44feb8d0ddd81856d.png";